import React from "react";
import Select from "react-select";

import { isEnabled } from "utils/featureFlags";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Toggle from "react-toggle";
import { Alert } from "react-bootstrap";

import { Button, ButtonGroup, Toast } from "aible";
import { OverlayTrigger, Popover } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp, faThumbsDown, faArrowAltCircleUp, faArrowAltCircleDown } from "@fortawesome/free-solid-svg-icons";

import numeral from "numeral";

import { LineInput } from "components/Inputs/LineInput";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import PieChart from "components/Project/PieChart";
import TinyBarChart from "components/Project/TinyBarChart";
import PredictionDriverToolTip from "components/Project/PredictionDriverToolTip";

import ImpactSlider from "components/Optimizer/ImpactSlider";
import CompareScenario from "components/Project/CompareScenario";

import RunPlotContainer from "containers/RunPlot/RunPlot";
import RunFrontierContainer from "containers/FrontierSliders/RunFrontier";
import AdvancedCostsContainer from "containers/CreateWizard/Costs/AdvancedCosts";

import { checkValueWarning, getWarningMessage } from "containers/Setup/reducer";
import { AIBLE_VIEW_TYPE, isSameSetup } from "containers/Project/reducer";

import ProjectHelp from "containers/UnifiedProject/Help/ProjectHelp";
import ProjectHelpItem from "components/UnifiedProject/Help/ProjectHelpItem";

import SankeyChart from "components/Optimizer/SankeyChart";
import OptimizeWarnings from "components/UnifiedProject/Optimize/Double/OptimizeWarnings";
import ContinuousAssumptionsCardContainer from "containers/UnifiedProject/Optimize/Subcontainers/ContinuousAssumptionsCard";
import BusinessConstraints from "containers/Business/Strategy/BusinessConstraints";

import { SegmentMetric } from "utils/optimizer/ProjectOptimizer";

import PurpleDataIcon from "images/PurpleDataIcon.svg";
import PurpleFlagIcon from "images/PurpleFlagIcon.svg";

import styles from "./style.module.css";

export default class DoubleOptimize extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isHammer: false,
      isHelpClosed: false,
      isDrivers: true,
      splitField: undefined
    };
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  renderAssumptions() {
    const {
      id,
      setup,
      blueprint,
      optimizer,
      optimized,
      isContinuous,
      customMappings,
      toggleCustomMapping,
      modelGroups,
      updateBaselineCustomValue,
      updateCustomValue,
      updateDrilldownValue,
      canEditAssumptions,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateBaselineConversionGain,
      updateBaselineConversionCost,
      updateBaselineConversionMissed,
      updateBaselineConversionSaved
    } = this.props;

    if (setup === undefined || Object.keys(setup).length === 0) {
      return <div />;
    }

    const isOverallSegment = this.getIsOverallSegment();

    const retId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

    const hasCustomValues =
      optimized &&
      optimized.setup &&
      optimized.setup.customValues &&
      Object.keys(optimized.setup.customValues).length > 0;

    const showCustomValues = hasCustomValues;

    console.log("are we here", this.props);

    return (
      <div>
        <div>
          <div className={styles.shareHeader}>
            <div className={styles.costSectionOne} style={{ paddingLeft: "0px" }}>
              {"Assumptions"}
            </div>
            <div className={styles.costSectionTwo}>{"Distribution"}</div>
            <div className={styles.costSectionThree} style={{ paddingRight: "0px" }}>
              {"Average"}
            </div>
          </div>
          {showCustomValues ? (
            <div
              className={styles.oItemBotContent}
              style={{
                marginTop: "0px"
              }}
            >
              <div className={styles.aholder}>
                {Object.keys(optimized.setup.customValues).map((c, i) => {
                  const bpDesc =
                    optimized &&
                    optimized.blueprint &&
                    optimized.blueprint &&
                    optimized.blueprint.wizard &&
                    optimized.blueprint.wizard.customFields &&
                    optimized.blueprint.wizard.customFields[c] &&
                    optimized.blueprint.wizard.customFields[c].desc
                      ? optimized.blueprint.wizard.customFields[c].desc
                      : c;

                  return (
                    <div key={i} className={styles.assumptionItem}>
                      <div className={styles.costSectionOne} title={bpDesc}>
                        {c}
                      </div>
                      <div className={styles.costSectionTwo}>
                        <ImpactSlider
                          impacts={modelGroups.drilldownValues.map((v) => ({
                            value: v.setup.customValues[c],
                            drilldownValue: v.value,
                            runId: v.runId,
                            color: v.color
                          }))}
                          currentImpact={optimized.setup.customValues[c]}
                          drilldownValue={optimizer.drilldownValue}
                          updateDrilldownValue={(runId, val) => updateCustomValue(retId, setup.blueprintId, c, val)}
                        />
                      </div>
                      <div className={styles.costSectionThree}>
                        {optimized.setup.customValues[c] !== undefined
                          ? Number(optimized.setup.customValues[c]).toFixed(2)
                          : ""}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div>
              {modelGroups && modelGroups.drilldownValues && (
                <div
                  className={styles.oItemBotContent}
                  style={{
                    marginTop: "0px"
                  }}
                >
                  <div className={styles.assumptionItem}>
                    <div className={styles.costSectionOne}>{optimized.setup.truePositiveLabel}</div>
                    <div className={styles.costSectionTwo}>
                      <ImpactSlider
                        impacts={modelGroups.drilldownValues.map((v) => ({
                          value: v.setup.conversionGain,
                          drilldownValue: v.value,
                          runId: v.runId,
                          color: v.color
                        }))}
                        currentImpact={optimized.setup.conversionGain}
                        drilldownValue={optimizer.drilldownValue}
                        updateDrilldownValue={(runId, v) => updateConversionGain(retId, v)}
                      />
                    </div>
                    <div className={styles.costSectionThree}>
                      {optimized.setup.conversionGain !== undefined
                        ? Number(optimized.setup.conversionGain).toFixed(2)
                        : ""}
                    </div>
                  </div>
                  <div className={styles.assumptionItem}>
                    <div className={styles.costSectionOne}>{optimized.setup.falsePositiveLabel}</div>
                    <div className={styles.costSectionTwo}>
                      <ImpactSlider
                        impacts={modelGroups.drilldownValues.map((v) => ({
                          value: v.setup.conversionCost,
                          drilldownValue: v.value,
                          runId: v.runId,
                          color: v.color
                        }))}
                        currentImpact={optimized.setup.conversionCost}
                        drilldownValue={optimizer.drilldownValue}
                        updateDrilldownValue={(runId, v) => updateConversionCost(retId, v)}
                      />
                    </div>
                    <div className={styles.costSectionThree}>
                      {optimized.setup.conversionCost !== undefined
                        ? Number(optimized.setup.conversionCost).toFixed(2)
                        : ""}
                    </div>
                  </div>
                  {!isContinuous ? (
                    <React.Fragment>
                      <div className={styles.assumptionItem}>
                        <div className={styles.costSectionOne}>{optimized.setup.trueNegativeLabel}</div>
                        <div className={styles.costSectionTwo}>
                          <ImpactSlider
                            impacts={modelGroups.drilldownValues.map((v) => ({
                              value: v.setup.conversionSaved,
                              drilldownValue: v.value,
                              runId: v.runId,
                              color: v.color
                            }))}
                            currentImpact={optimized.setup.conversionSaved}
                            drilldownValue={optimizer.drilldownValue}
                            updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                          />
                        </div>
                        <div className={styles.costSectionThree}>
                          {optimized.setup.conversionSaved !== undefined
                            ? Number(optimized.setup.conversionSaved).toFixed(2)
                            : ""}
                        </div>
                      </div>
                      <div className={styles.assumptionItem}>
                        <div className={styles.costSectionOne}>{optimized.setup.falseNegativeLabel}</div>
                        <div className={styles.costSectionTwo}>
                          <ImpactSlider
                            impacts={modelGroups.drilldownValues.map((v) => ({
                              value: v.setup.conversionGain,
                              drilldownValue: v.value,
                              runId: v.runId,
                              color: v.color
                            }))}
                            currentImpact={optimized.setup.conversionMissed}
                            drilldownValue={optimizer.drilldownValue}
                            updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                          />
                        </div>
                        <div className={styles.costSectionThree}>
                          {optimized.setup.conversionMissed !== undefined
                            ? Number(optimized.setup.conversionMissed).toFixed(2)
                            : ""}
                        </div>
                      </div>
                    </React.Fragment>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          )}
        </div>
        {isOverallSegment !== true && (
          <div style={{ marginTop: "20px" }}>
            {optimized ? (
              <div className={styles.aHeader}>
                <div style={{ width: "50%" }}>{"Assumptions"}</div>
                <div style={{ width: "50%" }}>{"Scenario"}</div>
              </div>
            ) : (
              <div className={styles.aHeader}>
                <div style={{ width: "50%" }}>{"Assumptions"}</div>
                <div style={{ width: "50%" }}>{"Scenario"}</div>
              </div>
            )}
            <div className={styles.aHolder}>
              {Object.keys(setup.customValues).map((v, i) => {
                const currMapping = customMappings && customMappings[v];

                const showWarning =
                  optimized &&
                  optimized.setup &&
                  optimized.setup.customValues &&
                  optimized.originalSetup &&
                  optimized.originalSetup.customValues
                    ? checkValueWarning(
                        optimized.setup.customValues[v],
                        optimized.originalSetup.customValues[v],
                        Boolean(currMapping)
                      )
                    : false;

                const bpDesc =
                  blueprint &&
                  blueprint &&
                  blueprint.wizard &&
                  blueprint.wizard.customFields &&
                  blueprint.wizard.customFields[v] &&
                  blueprint.wizard.customFields[v].desc
                    ? blueprint.wizard.customFields[v].desc
                    : v;

                const currValue = setup.customValues[v];
                const retCurrValue =
                  currValue && currMapping ? numeral(currValue).format(currValue > 100 ? "0" : "0.[00]") : currValue;

                return (
                  <React.Fragment key={v + i}>
                    <div className={styles.assumptionEditItem}>
                      <div className={styles.costEditThirdsOne} style={optimized === undefined ? { width: "50%" } : {}}>
                        <OverlayTrigger
                          placement={"top"}
                          trigger={["hover", "focus"]}
                          containerPadding={20}
                          overlay={
                            <Popover
                              id={"popover-positioned-top"}
                              title={
                                currMapping ? (
                                  <div>
                                    <span>{"Using values from the field "}</span>
                                    <strong>{currMapping}</strong>
                                  </div>
                                ) : undefined
                              }
                            >
                              {bpDesc}
                            </Popover>
                          }
                        >
                          <span>{v}</span>
                        </OverlayTrigger>
                        {currMapping && showWarning ? (
                          <OverlayTrigger
                            placement={"top"}
                            trigger={["hover", "focus"]}
                            containerPadding={20}
                            overlay={
                              <Popover>
                                <div
                                  style={{
                                    maxWidth: 300
                                  }}
                                >
                                  {"Reset " +
                                    v +
                                    "  to the observed average from the dataset (" +
                                    optimized.originalSetup.customValues[v] +
                                    ")."}
                                </div>
                              </Popover>
                            }
                          >
                            <a
                              className={styles.fieldReset}
                              onClick={() =>
                                updateCustomValue(retId, setup.blueprintId, v, optimized.originalSetup.customValues[v])
                              }
                            >
                              {"Reset"}
                            </a>
                          </OverlayTrigger>
                        ) : (
                          <React.Fragment />
                        )}
                      </div>
                      {/*
											<div
												className={styles.costEditThirdsTwo}
												style={
													optimized === undefined
														? { width: "50%" }
														: {}
												}
											>
												<div className={styles.cFieldInput}>
													<LineInput
														isMediumBox
														onChange={(val) =>
															updateBaselineCustomValue(
																retId,
																setup.blueprintId,
																v,
																val
															)
														}
														value={
															setup.baselineCustomValues &&
															setup.baselineCustomValues[
																v
															] !== undefined
																? setup
																		.baselineCustomValues[
																		v
																  ]
																: setup.customValues[v]
														}
														style={{ color: "#4B495B" }}
													/>
												</div>
											</div>
											*/}
                      <div className={styles.costEditThirdsThree}>
                        <OverlayTrigger
                          placement="top"
                          trigger={currMapping && !showWarning ? ["hover"] : []}
                          rootClose
                          overlay={
                            <Popover id="popover-positioned-top">
                              <div className={styles.tooltip}>
                                <span>
                                  {
                                    "Aible automatically populated this with the average value from the field you selected in the "
                                  }
                                </span>
                                <strong>{"Business Assumption Field Mapping"}</strong>
                                <span>{" section of the "}</span>
                                <strong>{"Data Setup"}</strong>
                              </div>
                            </Popover>
                          }
                        >
                          <div className={styles.cFieldInput}>
                            <LineInput
                              isMediumBox
                              onChange={(val) => updateCustomValue(retId, setup.blueprintId, v, val)}
                              value={retCurrValue}
                              style={{ color: "#4B495B" }}
                              isWarning={showWarning}
                              warning={
                                showWarning &&
                                getWarningMessage(
                                  optimized.setup.customValues[v],
                                  optimized.originalSetup.customValues[v],
                                  "Scenario",
                                  "Blueprint",
                                  currMapping
                                )
                              }
                            />
                          </div>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}

              {Object.keys(setup.customValues).length === 0 ? (
                <div>
                  <div className={styles.assumptionEditItem}>
                    <div className={styles.costEditThirdsOne} style={optimized === undefined ? { width: "50%" } : {}}>
                      {setup.truePositiveLabel}
                    </div>
                    {/*
										<div
											className={styles.costEditThirdsTwo}
											style={
												optimized === undefined
													? { width: "50%" }
													: {}
											}
										>
											<LineInput
												isMediumBox
												value={
													setup.baselineConversionGain !==
													undefined
														? setup.baselineConversionGain
														: setup.conversionGain
												}
												onChange={(val) =>
													updateBaselineConversionGain(
														retId,
														val
													)
												}
												style={{ color: "#4B495B" }}
											/>
										</div>
										*/}
                    <div className={styles.costEditThirdsThree}>
                      <LineInput
                        isMediumBox
                        value={setup.conversionGain}
                        onChange={(val) => updateConversionGain(retId, val)}
                        style={{ color: "#4B495B" }}
                      />
                    </div>
                  </div>
                  <div className={styles.assumptionEditItem}>
                    <div className={styles.costEditThirdsOne} style={optimized === undefined ? { width: "50%" } : {}}>
                      {setup.falsePositiveLabel}
                    </div>
                    {/*
										<div
											className={styles.costEditThirdsTwo}
											style={
												optimized === undefined
													? { width: "50%" }
													: {}
											}
										>
											<LineInput
												isMediumBox
												value={
													setup.baselineConversionCost !==
													undefined
														? setup.baselineConversionCost
														: setup.conversionCost
												}
												onChange={(val) =>
													updateBaselineConversionCost(
														retId,
														val
													)
												}
												style={{ color: "#4B495B" }}
											/>
										</div>
										*/}

                    <div className={styles.costEditThirdsThree}>
                      <LineInput
                        isMediumBox
                        value={setup.conversionCost}
                        onChange={(val) => updateConversionCost(retId, val)}
                        style={{ color: "#4B495B" }}
                      />
                    </div>
                  </div>
                  {!isContinuous ? (
                    <React.Fragment>
                      <div className={styles.assumptionEditItem}>
                        <div
                          className={styles.costEditThirdsOne}
                          style={optimized === undefined ? { width: "50%" } : {}}
                        >
                          {setup.trueNegativeLabel}
                        </div>
                        {/*
												<div
													className={styles.costEditThirdsTwo}
													style={
														optimized === undefined
															? { width: "50%" }
															: {}
													}
												>
													<LineInput
														isMediumBox
														value={
															setup.baselineConversionSaved !==
															undefined
																? setup.baselineConversionSaved
																: setup.conversionSaved
														}
														onChange={(val) =>
															updateBaselineConversionSaved(
																retId,
																val
															)
														}
														style={{ color: "#4B495B" }}
													/>
												</div>
												*/}

                        <div className={styles.costEditThirdsThree}>
                          <LineInput
                            isMediumBox
                            value={setup.conversionSaved}
                            onChange={(val) => updateConversionSaved(retId, val)}
                            style={{ color: "#4B495B" }}
                          />
                        </div>
                      </div>
                      <div className={styles.assumptionEditItem}>
                        <div
                          className={styles.costEditThirdsOne}
                          style={optimized === undefined ? { width: "50%" } : {}}
                        >
                          {setup.falseNegativeLabel}
                        </div>
                        {/*
											<div
												className={styles.costEditThirdsTwo}
												style={
													optimized === undefined
														? { width: "50%" }
														: {}
												}
											>
												<LineInput
													isMediumBox
													value={
														setup.baselineConversionMissed !==
														undefined
															? setup.baselineConversionMissed
															: setup.conversionMissed
													}
													onChange={(val) =>
														updateBaselineConversionMissed(
															retId,
															val
														)
													}
													style={{ color: "#4B495B" }}
												/>
											</div>
											*/}

                        <div className={styles.costEditThirdsThree}>
                          <LineInput
                            isMediumBox
                            value={setup.conversionMissed}
                            onChange={(val) => updateConversionMissed(retId, val)}
                            style={{ color: "#4B495B" }}
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <div />
              )}
              <OptimizeWarnings setup={this.props.setup} isContinuous={this.props.isContinuous} />
              {/*this.renderWarningAlert()*/}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderProgress(label) {
    const { optimized } = this.props;

    return (
      <div className={styles.eLight}>
        <div className={styles.lFlex}>
          <div className={styles.eCircle} />
          {optimized && optimized.isCreating ? "Finding Optimal " + label : "Optimization Not Started"}
        </div>
        <div className={styles.eLightBar} />
      </div>
    );
  }

  renderMix() {
    const {
      project,
      createSplits,
      optimized,
      optimizer,
      splitOptions,
      isContinuous,
      modelGroups,
      updateDrilldownValue
    } = this.props;
    const { isCreating, splitField } = this.state;

    const drilldownValues = (modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues) || [];

    let drilldownSlice = undefined;

    for (let value of drilldownValues) {
      if (
        value.value != "Overall" &&
        (optimizer.drilldownValue == "Overall" || value.value === optimizer.drilldownValue)
      ) {
        drilldownSlice = value;
        break;
      }
    }

    const otherSlices = drilldownSlice
      ? drilldownValues.filter((v) => v && v.column && v.column == drilldownSlice.column && v.column !== "Overall")
      : undefined;

    let loadingSplits = false;

    otherSlices &&
      otherSlices.forEach((v) => {
        if (isNaN(v.optimalPct)) {
          loadingSplits = true;
        }
      });

    const darkSelectStyle = {
      option: (provided, state) => ({
        ...provided,
        background: state.isFocused ? "#512f77" : "#362e30",
        color: "white !important"
      }),
      control: (provided, state) => ({
        ...provided,
        background: "#362e44",
        border: "1px solid #828282",
        color: "white !important"
        // none of react-select's styles are passed to <Control />
      }),
      singleValue: (provided, state) => ({
        ...provided,
        color: "white"
      }),
      menuList: (provided, state) => ({
        ...provided,
        paddingTop: "0px",
        paddingBottom: "0px"
      })
    };

    const pieData = otherSlices
      ? otherSlices.map((s) => ({
          name: s.value,
          runId: s.runId,
          value: Math.round(s.optimalPct),
          color: s.color
        }))
      : [];

    return (
      <div className={styles.mixHolder} style={{ overflow: "visible" }}>
        {project && project.segments && project.segments.length === 1 && isCreating !== true ? (
          <div className={styles.splitFieldHolder}>
            <div className={styles.oItemBotHeader} style={{ textAlign: "center" }}>
              {"Split on Field"}
            </div>
            <div className={styles.splitField}>
              <Select
                value={splitField && splitOptions.find((o) => o.value === splitField)}
                options={splitOptions}
                onChange={(o) => {
                  this.setState({ splitField: o.value });
                }}
                styles={darkSelectStyle}
              />
            </div>
            <Button
              onClick={() => {
                if (splitField === undefined) {
                  return;
                }
                this.setState({ isCreating: true });
                setTimeout(() => this.setState({ isCreating: false, splitField: undefined }), 5000);
                createSplits(splitField ? splitField : undefined);
              }}
              style={
                splitField === undefined
                  ? { whiteSpace: "nowrap", opacity: 0, cursor: "default" }
                  : { whiteSpace: "nowrap" }
              }
              isDark
            >
              {"Create Subgroups"}
            </Button>
          </div>
        ) : (!isContinuous && loadingSplits) || isCreating ? (
          <div className={styles.smallLoader} style={{ padding: "2vw" }}>
            <LoadingIndicator style={{ marginTop: "-20px" }} color={"#868595"} />
            <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Training AI Models"}</div>
          </div>
        ) : isContinuous ? (
          <React.Fragment />
        ) : pieData.find((e) => e.value) ? (
          <div>
            <div className={styles.pieHolder}>
              <PieChart
                showSegments
                pData={pieData}
                onClick={(runId, name) => updateDrilldownValue(runId, name)}
                unit={optimized.unitLabelShort}
              />
            </div>
          </div>
        ) : (
          <React.Fragment />
        )}
      </div>
    );
  }

  parseValueName(name) {
    if (name.includes("more than ") && name.includes(" to ")) {
      return name.replace("more than", ">");
    }
    return name;
  }

  renderDrivers(topDrivers, count = 10, showValues = false) {
    const { updateModelFeedback, username } = this.props;

    const feedbackCount =
      topDrivers && topDrivers.bestModel && topDrivers.segment && topDrivers.segment.roles
        ? topDrivers.segment.roles.reduce(
            (a, b) =>
              a +
              (b &&
              b.preferences &&
              b.preferences.feedback &&
              b.preferences.feedback[topDrivers.bestModel.id] !== undefined
                ? Number(b.preferences.feedback[topDrivers.bestModel.id])
                : 0),
            0
          )
        : 0;

    return topDrivers === undefined ? (
      <div />
    ) : (
      <div style={{ marginBottom: "20px" }} key={topDrivers.drilldownValue}>
        <div className={styles.dHeader} style={{ fontWeight: "bold", background: topDrivers.color }}>
          {topDrivers.drilldownValue}
          <div className={styles.dFeedback}>
            <ButtonGroup>
              <Button
                onClick={
                  topDrivers.bestModel && topDrivers.bestModel.id !== undefined
                    ? () => updateModelFeedback(topDrivers.runId, topDrivers.bestModel.id, true)
                    : () => {}
                }
                style={{ padding: "5px" }}
              >
                <FontAwesomeIcon icon={faThumbsUp} />
              </Button>
              <Button
                onClick={
                  topDrivers.bestModel && topDrivers.bestModel.id !== undefined
                    ? () => updateModelFeedback(topDrivers.runId, topDrivers.bestModel.id, false)
                    : () => {}
                }
                style={{ padding: "5px" }}
              >
                <FontAwesomeIcon icon={faThumbsDown} />
              </Button>
            </ButtonGroup>
            <div className={styles.dNumber}>{(feedbackCount > 0 ? "+" : "") + feedbackCount}</div>
          </div>
        </div>
        {topDrivers && topDrivers.columnDrivers === undefined ? (
          <LoadingIndicator style={{ margin: "0px", marginBottom: "20px" }} />
        ) : (
          <div />
        )}
        {topDrivers &&
          topDrivers.columnDrivers &&
          topDrivers.columnDrivers
            .filter((m, i) => i < count && m.maxName != m.minName)
            .map((m, i) => (
              <div className={styles.driverWrapper + " " + (showValues ? styles.hasValues : "")} key={i + m.field}>
                <div className={styles.driverTitle + " " + (showValues ? "" : styles.hideValues)}>{m.field}</div>
                {showValues ? (
                  <React.Fragment>
                    {m.maxName !== undefined ? (
                      <div className={styles.driverItem}>
                        <span className={styles.botDelta + " " + styles.increase}>
                          <FontAwesomeIcon
                            style={{
                              marginRight: "10px"
                            }}
                            icon={faArrowAltCircleUp}
                          />
                        </span>
                        <div>
                          <div>{this.parseValueName(m.maxName)}</div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {m.minName !== undefined ? (
                      <div className={styles.driverItem}>
                        <span className={styles.botDelta + " " + styles.decrease}>
                          <FontAwesomeIcon
                            style={{
                              marginRight: "10px"
                            }}
                            icon={faArrowAltCircleDown}
                          />
                        </span>
                        <div>
                          <div>{this.parseValueName(m.minName)}</div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
            ))}
      </div>
    );
  }

  renderIsContinuous() {
    const {
      id,
      currentSpend,
      currentRevenue,
      currentProfit,
      setup,
      optimized,
      isRealityHammer,
      project,
      modelGroups,
      runId,
      model,
      setMaxBudget,
      setMinBudget,
      updateScaledTotal,
      updateOutcomePercentage,
      updateIsRealityHammer,
      history,
      optimizer,
      isEditBlueprint
    } = this.props;

    const { isHammer, isCompare, isDrivers, isCreating } = this.state;

    const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";

    const underPredictLabel = setup.underPredictAction ? setup.underPredictAction : "Underestimate Cost";

    const overPredictLabel = setup.overPredictAction ? setup.overPredictAction : "Overestimate Cost";

    const minBudget =
      project &&
      project.settings.segmentMinBudgets &&
      project.settings.segmentMinBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMinBudgets[optimized.segmentId]
        : undefined;

    const maxBudget =
      project &&
      project.settings.segmentMaxBudgets &&
      project.settings.segmentMaxBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMaxBudgets[optimized.segmentId]
        : undefined;

    const mSubGroup =
      optimizer &&
      modelGroups &&
      optimizer.drilldownValue &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.value === optimizer.drilldownValue).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.value === optimizer.drilldownValue)[0]
        : undefined;

    const isOverallSegment = this.getIsOverallSegment();

    return (
      <div
        className={styles.emptyOptimize}
        style={optimized && optimized.isCreating === false ? { paddingBottom: "200px" } : {}}
      >
        <div className={styles.emptyTop}>
          <ProjectHelp
            title={
              isEditBlueprint
                ? "Editing Blueprint: Business Cost Benefits and Labels"
                : optimized
                  ? "Predict Business Impact by Adjusting Business Assumptions"
                  : "Add Baseline Business Assumptions to Optimize Business Impact"
            }
            isDark
            onToggle={(isClosed) => this.setState({ isHelpClosed: isClosed })}
            noBot
          >
            {isEditBlueprint !== true ? (
              <React.Fragment>
                <ProjectHelpItem isDark type={"targetGrey"}>
                  {"After Training the AI Aible will show the recommended resourcing, " +
                    "mix, and revenue that optimizes your profit and compares it to the baseline."}
                </ProjectHelpItem>
                <ProjectHelpItem isDark type={"rocketGrey"}>
                  {"You will be able to keep changing these assumptions even after training the AI."}
                </ProjectHelpItem>
              </React.Fragment>
            ) : (
              ""
            )}
          </ProjectHelp>
          <div className={styles.eBoxHolder}>
            {optimized && optimized.isCreating === false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Predicted " + underPredictLabel}</div>
                <div className={styles.eSubDark}>
                  {"This is the sum of the underestimate costs for all underestimated " + transactionLabel + "."}
                </div>
                <div className={styles.eLightLarge}>
                  {optimized?.unitLabel && optimized?.unitLabel === "$" && optimized?.unitLabel}
                  {numeral(optimized.underEstimate).format("0.0a")}
                </div>
              </div>
            ) : optimized && optimized.isCreating ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Optimizing " + underPredictLabel}</div>
                <div className={styles.eLoading}>
                  <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
                </div>
                {this.renderProgress(underPredictLabel)}
              </div>
            ) : (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Baseline " + underPredictLabel}</div>
                <div className={styles.eSubDark}>
                  {"This is your Business Assumptions Costs (the total cost " +
                    "per opportunity) times the Total Opportunities " +
                    "you expect to pursue."}
                </div>
                <div className={styles.eDarkLarge}>{""}</div>
              </div>
            )}
            {optimized && optimized.isCreating === false && (
              <div className={styles.pieHolderCont}>
                <div className={styles.eDarkCont}>{underPredictLabel + " Mix"}</div>
                <PieChart
                  showSegments
                  pData={
                    modelGroups?.drilldownValues
                      ? modelGroups.drilldownValues
                          .filter((d, i) => i > 0)
                          .map((d) => ({
                            name: d?.value,
                            value: d?.bestModel?.metrics?.sum_under_predict,
                            color: d?.color
                          }))
                      : []
                  }
                  unit={optimized.unitLabelShort}
                />
              </div>
            )}
            {optimized && optimized.isCreating === false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Predicted " + overPredictLabel}</div>
                <div className={styles.eSubDark}>
                  {"This is the sum of the overestimate costs for all overestimated " + transactionLabel + "."}
                </div>
                <div className={styles.eLightLarge}>
                  {optimized?.unitLabel && optimized?.unitLabel === "$" && optimized?.unitLabel}
                  {numeral(optimized.overEstimate).format("0.0a")}
                </div>
              </div>
            ) : optimized && optimized.isCreating ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Optimizing " + overPredictLabel}</div>
                <div className={styles.eLoading}>
                  <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
                </div>
                {this.renderProgress(overPredictLabel)}
              </div>
            ) : (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Baseline " + overPredictLabel}</div>
                <div className={styles.eSubDark}>
                  {"This uses your Business Assumption Benefits (expected revenue " +
                    "per opportunitiy) times your Total Expected Win Count."}
                </div>
                <div className={styles.eDarkLarge}>{""}</div>
              </div>
            )}
            {optimized && optimized.isCreating === false && (
              <div className={styles.pieHolderCont}>
                <div className={styles.eDarkCont}>{overPredictLabel + " Mix"}</div>
                <PieChart
                  showSegments
                  pData={
                    modelGroups?.drilldownValues
                      ? modelGroups.drilldownValues
                          .filter((d, i) => i > 0)
                          .map((d) => ({
                            name: d?.value,
                            value: d?.bestModel?.metrics?.sum_over_predict,
                            color: d?.color
                          }))
                      : []
                  }
                  unit={optimized.unitLabelShort}
                />
              </div>
            )}
            {optimized &&
            optimized.isCreating === false &&
            project &&
            project.segments &&
            project.segments.length === 1 ? (
              <div className={styles.eBox}>{this.renderMix()}</div>
            ) : (
              ""
            )}
            {optimized && optimized.isCreating === false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Expected Overall Error"}</div>
                <div className={styles.eSubDark}>
                  {"This is the sum of your total underestimate and overestimate costs."}
                </div>
                <div className={styles.eLightLarge}>
                  {optimized?.unitLabel && optimized?.unitLabel === "$" && optimized?.unitLabel}
                  {numeral(optimized.overEstimate + optimized.underEstimate).format("0.0a")}
                </div>
              </div>
            ) : optimized && optimized.isCreating ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Expected Overall Error"}</div>
                <div className={styles.eLoading}>
                  <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
                </div>
                {this.renderProgress("Error Cost")}
              </div>
            ) : (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Baseline Overall Error"}</div>
                <div className={styles.eSubDark}>
                  {"This is the sum of the unique businesss circumstances you defined" +
                    " in the Costs/Benefits and Expected Win Count across all" +
                    " potential opportunities."}
                </div>
                <div className={styles.eDarkLarge}>{""}</div>
              </div>
            )}
            {optimized && optimized.isCreating === false && (
              <div className={styles.pieHolderCont}>
                <div className={styles.eDarkCont}>{"Error Mix"}</div>
                <PieChart
                  showSegments
                  pData={
                    modelGroups?.drilldownValues
                      ? modelGroups.drilldownValues
                          .filter((d, i) => i > 0)
                          .map((d) => ({
                            name: d?.value,
                            value: d?.bestModel?.metrics?.sum_under_predict + d?.bestModel?.metrics?.sum_over_predict,
                            color: d?.color
                          }))
                      : []
                  }
                  unit={optimized.unitLabelShort}
                />
              </div>
            )}
          </div>
        </div>
        {isEditBlueprint ? (
          this.renderEditBlueprintBot()
        ) : (
          <div className={styles.emptyBot}>
            <div
              className={styles.eBotHeader}
              style={
                mSubGroup
                  ? {
                      background: mSubGroup.column === "Overall" ? "#7E69D7" : mSubGroup.color,
                      color: mSubGroup.color === "#7E69D7" || mSubGroup.column === "Overall" ? "white" : "#4B495B"
                    }
                  : {}
              }
            >
              <div className={styles.eBotHeaderItem} style={{ minWidth: "calc(40% - 40px)" }}>
                {"Business Assumptions"}
              </div>
              <div
                className={styles.eBotHeaderItem}
                style={{
                  minWidth: "calc(30% - 40px)",
                  marginRight: "20px"
                }}
              >
                {"Behavior Assumptions"}
              </div>
              <div
                className={styles.eBotHeaderItem}
                style={{
                  minWidth: "calc(30% - 40px)",
                  marginRight: "20px"
                }}
              >
                {"Key Drivers of Predictions"}
              </div>
            </div>
            <div className={styles.eBotBody}>
              <div className={styles.eBotItem} style={{ minWidth: "calc(40% - 40px)" }}>
                {this.renderAssumptions()}
              </div>
              <div className={styles.eFlex}>
                <div
                  className={styles.eBotItem}
                  style={{
                    padding: "0px"
                  }}
                >
                  {optimized && optimized.isCreating === false ? (
                    <ContinuousAssumptionsCardContainer id={this.props.id} />
                  ) : (
                    this.renderOptimizePlaceholder()
                  )}
                </div>
              </div>
              <div
                className={styles.eBotItem}
                style={{
                  minWidth: "calc(30% - 40px)",
                  marginRight: "20px"
                }}
              >
                {optimized && optimized.isCreating === false ? (
                  isOverallSegment || isDrivers ? (
                    <div>
                      <div className={styles.aHeader} style={{ marginBottom: "10px" }}>
                        {"Key Drivers"}
                        <PredictionDriverToolTip />
                      </div>
                      <div className={styles.nItemBotContent} style={{ overflow: "auto" }}>
                        {isOverallSegment
                          ? modelGroups.topDrivers.filter((s, i) => i > 0).map((s) => this.renderDrivers(s, 4, false))
                          : this.renderDrivers(
                              (modelGroups.topDrivers || []).find((driver) => driver.runId === optimized.innerId),
                              5,
                              true
                            )}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className={styles.mRunFrontier}>
                        <RunFrontierContainer id={runId} projectId={id} />
                      </div>
                      <div
                        className={styles.runPlot}
                        style={{
                          height: this.state.isHelpClosed ? "37vh" : "30vh"
                        }}
                      >
                        {
                          <RunPlotContainer
                            id={runId}
                            isMiniOptimize
                            projectId={project ? project.id : undefined}
                            forceEnableBts
                            hideFrontier
                          />
                        }
                      </div>
                    </div>
                  )
                ) : (
                  <div className={styles.eBotBox}>
                    <img src={PurpleFlagIcon} className={styles.eIcon} />
                    <div className={styles.eBotBoxBold}>
                      {"Once the AI has been trained this section will " +
                        "display the model that best fits your use case."}
                    </div>
                    <div>
                      {"The optimal model will be based on the cost, benefit, and" +
                        " data assumptions you defined in the first two sections."}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  getBaselines() {
    const { id, setup, runId } = this.props;

    const { truePositive, falsePositive, trueNegative, falseNegative } = this.getCounts(true);

    const pursued = truePositive + falsePositive;
    const notPursued = trueNegative + falseNegative;

    const baselineTotal = pursued + notPursued;

    const bPositives = truePositive + falseNegative;
    const bNegatives = falsePositive + trueNegative;

    const baselineTotalWinRate = ((bPositives / (bPositives + bNegatives)) * 100).toFixed(2);

    return {
      baselineWinRate: baselineTotalWinRate,
      baselineTotal: baselineTotal
    };
  }

  renderOptimizePlaceholder() {
    return (
      <div className={styles.eBotBox} style={{ padding: "20px" }}>
        <img src={PurpleFlagIcon} className={styles.eIcon} />
        <div className={styles.eBotBoxBold}>
          {"Once the AI has been trained this section will allow you " +
            "to set capacity limits and adjust behavior assumptions."}
        </div>
      </div>
    );
  }

  renderEditBlueprintBot() {
    const { setup, project, blueprintId, runId } = this.props;

    return (
      <div className={styles.emptyBot}>
        <div className={styles.eBotHeader}>
          <div className={styles.eBotHeaderItem} style={{ minWidth: "calc(50% - 40px)" }}>
            {"Edit Business Assumptions"}
          </div>
          <div
            className={styles.eBotHeaderItem}
            style={{
              minWidth: "calc(50% - 40px)",
              marginRight: "20px"
            }}
          >
            {"Custom Functions"}
          </div>
        </div>
        <div className={styles.eBotBody}>
          <div className={styles.eBotBlueprint} style={{ minWidth: "100%" }}>
            <AdvancedCostsContainer
              id={runId}
              runId={runId}
              blueprintId={setup && setup.blueprintId ? setup.blueprintId : "newBlueprint"}
              projectId={project ? project.id : undefined}
              isOptimizer
            />
          </div>
        </div>
      </div>
    );
  }

  renderSankey() {
    const { optimized } = this.props;

    return optimized && optimized.isLinkedProjectLoading ? <LoadingIndicator /> : <SankeyChart optimized={optimized} />;
  }

  getLabels() {
    const { optimized } = this.props;

    if (
      optimized === undefined ||
      optimized.first === undefined ||
      optimized.first.setup === undefined ||
      optimized.second === undefined ||
      optimized.second.setup === undefined
    ) {
      return {};
    }

    const fSetup = optimized.first.setup;
    const fTransactionLabel = fSetup.transactionLabel ? fSetup.transactionLabel : "Leads";
    const fNotPursuedTransactionLabel = fSetup.notPursuedTransactionLabel
      ? fSetup.notPursuedTransactionLabel
      : "Potential " + fTransactionLabel;
    const fTrueAction = fSetup.trueAction ? fSetup.trueAction : "Pursue";
    const fFalseAction = fSetup.falseAction ? fSetup.falseAction : "Ignore";

    const sSetup = optimized.second.setup;
    const sTransactionLabel = sSetup.transactionLabel ? sSetup.transactionLabel : "Opportunities";
    const sNotPursuedTransactionLabel = sSetup.notPursuedTransactionLabel
      ? sSetup.notPursuedTransactionLabel
      : "Potential " + sTransactionLabel;
    const sTrueAction = sSetup.trueAction ? sSetup.trueAction : "Pursue";
    const sFalseAction = sSetup.falseAction ? sSetup.falseAction : "Ignore";

    return {
      fTransactionLabel,
      fNotPursuedTransactionLabel,
      fTrueAction,
      fFalseAction,
      fTruePositive: fSetup.truePositiveLabel,
      sTransactionLabel,
      sNotPursuedTransactionLabel,
      sTrueAction,
      sFalseAction,
      sTruePositive: sSetup.truePositiveLabel
    };
  }

  renderTopSankey() {
    const { optimized } = this.props;

    const labels = this.getLabels();

    if (optimized === undefined || optimized.first === undefined || optimized.second === undefined) {
      return <div />;
    }

    return (
      <div className={styles.sankeyTop}>
        <div className={styles.sMsg}>{"Optimized Pipeline"}</div>
        <div className={styles.sankeyBot}>
          <div className={styles.sankeyLeft}>
            <div className={styles.sItem}>
              <div className={styles.sTop}>{numeral(optimized.first.totalProspects).format("0.0a")}</div>
              <div className={styles.sBot}>{labels.fTransactionLabel}</div>
            </div>
            <div className={styles.sItem}>
              <div className={styles.sTop}>{numeral(optimized.first.totalPursued).format("0.0a")}</div>
              <div className={styles.sBot}>{labels.fTransactionLabel + ": " + labels.fTrueAction}</div>
            </div>
            <div className={styles.sItem}>
              <div className={styles.sTop}>{numeral(optimized.first.totalWon).format("0.0a")}</div>
              <div className={styles.sBot}>{labels.fTruePositive}</div>
            </div>
          </div>
          <div className={styles.sankeyRight}>
            <div className={styles.sItem}>
              <div className={styles.sTop}>{numeral(optimized.first.totalWon).format("0.0a")}</div>
              <div className={styles.sBot}>{labels.sTransactionLabel}</div>
            </div>
            <div className={styles.sItem}>
              <div className={styles.sTop}>{numeral(optimized.second.totalPursued).format("0.0a")}</div>
              <div className={styles.sBot}>{labels.sTransactionLabel + ": " + labels.sTrueAction}</div>
            </div>
            <div className={styles.sItem}>
              <div className={styles.sTop}>{numeral(optimized.second.totalWon).format("0.0a")}</div>
              <div className={styles.sBot}>{labels.sTruePositive}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Uses subgroup counts to make overall counts if overall
  getCounts(isBaseline = false) {
    const { setup, modelGroups } = this.props;
    if (!this.getIsOverallSegment()) {
      const countsObj = isBaseline && setup.isRealityHammer && setup.baselineCounts ? setup.baselineCounts : setup;
      return {
        truePositive: Number(countsObj.truePositive),
        falsePositive: Number(countsObj.falsePositive),
        trueNegative: Number(countsObj.trueNegative),
        falseNegative: Number(countsObj.falseNegative)
      };
    }
    const retCounts = {
      truePositive: 0,
      falsePositive: 0,
      trueNegative: 0,
      falseNegative: 0
    };
    modelGroups.drilldownValues
      .filter((d) => d.value !== "Overall")
      .map((d) => d.setup)
      .forEach((currSetup) => {
        const countsObj =
          isBaseline && currSetup.isRealityHammer && currSetup.baselineCounts ? currSetup.baselineCounts : currSetup;
        retCounts.truePositive = retCounts.truePositive + Number(countsObj.truePositive);
        retCounts.falsePositive = retCounts.falsePositive + Number(countsObj.falsePositive);
        retCounts.trueNegative = retCounts.trueNegative + Number(countsObj.trueNegative);
        retCounts.falseNegative = retCounts.falseNegative + Number(countsObj.falseNegative);
      });
    return retCounts;
  }

  render() {
    const {
      id,
      approvedScenario,
      isContinuous,
      getIsContinuous,
      currentSpend,
      currentRevenue,
      currentProfit,
      setup,
      isEditBlueprint,
      isBalance,
      hasLinkedProject,
      linkedProject,
      isOptimizerWithinBounds,
      linkedProjectOutputModeOption,
      linkedProjectOutputModeOptions,
      isLoadingLink,
      optimized,
      optimizer,
      isRealityHammer,
      project,
      modelGroups,
      runId,
      model,
      projects,
      setMaxBudget,
      setMinBudget,
      updateLinkedProjectId,
      updateScaledTotal,
      updateOutcomePercentage,
      updateIsRealityHammer,
      updateHasLinkedProject,
      updateNetImpactLabel,
      updateAdvancedCostLabel,
      updateAdvancedRevenueLabel,
      updateAdvancedProfitLabel,
      updateLinkedScenarioId,
      updateLinkedProjectOutputMode,
      history,
      goToBalance
    } = this.props;

    const { isHammer, isCompare, isDrivers } = this.state;

    const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";

    const truePositiveLabel = setup.truePositiveLabel ? setup.truePositiveLabel : "True Positive";

    const outcomeLabel =
      setup.outcomeLabel == undefined
        ? setup.success && setup.success.label !== undefined
          ? setup.success.label
          : truePositiveLabel
        : setup.outcomeLabel;

    const { truePositive, falsePositive, trueNegative, falseNegative } = this.getCounts();
    const pursued = Number(truePositive) + Number(falsePositive);
    const notPursued = Number(trueNegative) + Number(falseNegative);
    const total = pursued + notPursued;

    const positives = Number(truePositive) + Number(falseNegative);
    const negatives = Number(falsePositive) + Number(trueNegative);

    const totalWinRate =
      positives + negatives !== 0
        ? ((positives / (positives + negatives)) * 100).toFixed(2)
        : setup.outcomePercentage === undefined
          ? 0
          : setup.outcomePercentage * 100;

    const minBudget =
      project &&
      project.settings.segmentMinBudgets &&
      project.settings.segmentMinBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMinBudgets[optimized.segmentId]
        : undefined;

    const maxBudget =
      project &&
      project.settings.segmentMaxBudgets &&
      project.settings.segmentMaxBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMaxBudgets[optimized.segmentId]
        : undefined;

    const isOverallSegment = this.getIsOverallSegment();

    const retIsContinuous = isContinuous || (optimized && optimized.underEstimate !== undefined);

    const mSubGroup =
      optimizer &&
      modelGroups &&
      optimizer.drilldownValue &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.value === optimizer.drilldownValue).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.value === optimizer.drilldownValue)[0]
        : undefined;

    const unitType = setup.unitType !== undefined ? setup.unitType : "$";

    const isSkipped =
      approvedScenario &&
      optimized &&
      isSameSetup(approvedScenario.data, optimized.setup) &&
      setup &&
      setup.isFastTrain;

    const baselines = this.getBaselines();

    return retIsContinuous ? (
      this.renderIsContinuous()
    ) : (
      <div
        className={styles.emptyOptimize}
        style={optimized && optimized.isCreating === false ? { paddingBottom: "200px" } : {}}
      >
        <div className={styles.emptyTop}>
          {isBalance ? (
            <div className={styles.pTitle}>{"Enterprise Resourcing Balancing & Optimization"}</div>
          ) : (
            <ProjectHelp
              title={
                isEditBlueprint
                  ? "Editing Blueprint: Business Cost Benefits and Labels"
                  : "Add Business Assumptions to Optimize the AI Business Impact"
              }
              isDark
              onToggle={(isClosed) => this.setState({ isHelpClosed: isClosed })}
              noBot
            >
              {isEditBlueprint !== true && (
                <ProjectHelpItem isDark type={"targetGrey"}>
                  {"After Training the AI Aible will show the recommended resourcing, " +
                    "mix, and revenue that optimizes your profit and compares it to the baseline."}
                </ProjectHelpItem>
              )}
              {isEditBlueprint !== true && (
                <ProjectHelpItem isDark type={"rocketGrey"}>
                  {"You will be able to keep changing these assumptions even after training the AI."}
                </ProjectHelpItem>
              )}
            </ProjectHelp>
          )}
          <div className={styles.eBoxHolder}>
            {isEditBlueprint ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>
                  <LineInput
                    isMediumBox
                    isDark
                    defaultValue={
                      optimized
                        ? optimized.resourcingLabel
                        : setup && setup.resourcingLabel
                          ? setup.resourcingLabel
                          : "Resourcing"
                    }
                    onChange={(val) => {
                      updateAdvancedCostLabel(runId, val);
                      updateAdvancedCostLabel("new", val);
                    }}
                  />
                </div>
                <div className={styles.eLightLarge}>{"TBD"}</div>
                <div>{"TBD"}</div>
              </div>
            ) : optimized && optimized.isCreating === false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{optimized.resourcingLabel}</div>
                <div className={styles.eLightLarge}>
                  {optimized.isCurrencyUnitType ? (
                    <div>
                      {unitType}
                      {numeral(optimized.totalCost).format("0.0a")}
                    </div>
                  ) : (
                    <div className={styles.nonC}>
                      {numeral(optimized.totalCost).format("0.0a")}
                      <div className={styles.subLabel}>{unitType}</div>
                    </div>
                  )}
                </div>
                {isSkipped !== true ? (
                  <TinyBarChart
                    bars={[
                      {
                        label: "Optimal " + optimized.resourcingLabel,
                        Cost: optimized.totalCost
                      },
                      {
                        label: "Current " + optimized.resourcingLabel,
                        Cost: optimized.currentSpend
                      }
                    ]}
                    unit={optimized.unitLabel}
                    isCurrencyUnit={optimized.isCurrencyUnitType}
                  />
                ) : (
                  <div>{"Add baseline assumptions to show difference"}</div>
                )}
              </div>
            ) : optimized && optimized.isCreating ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{optimized.resourcingLabel}</div>
                <div className={styles.eLoading}>
                  <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
                </div>
                {this.renderProgress("Resourcing")}
              </div>
            ) : (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Baseline Resourcing"}</div>
                <div className={styles.eSubDark}>
                  {"This is your Business Assumptions Costs (the total cost " +
                    "per opportunity) times the Total Opportunities " +
                    "you expect to pursue."}
                </div>
                <div className={styles.eDarkLarge}>
                  {unitType === "$" ? (
                    <div>
                      {unitType}
                      {numeral(currentSpend).format("0.0a")}
                    </div>
                  ) : (
                    <div className={styles.nonC}>
                      {numeral(currentSpend).format("0.0a")}
                      <div className={styles.subLabel}>{unitType}</div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {isEditBlueprint ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Recommended Mix"}</div>
              </div>
            ) : optimized && optimized.isCreating === false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Recommended Mix"}</div>
                {this.renderMix()}
              </div>
            ) : optimized && optimized.isCreating ? (
              <div className={styles.eBox} style={{ justifyContent: "flex-start" }}>
                <div className={styles.eDark}>{"Recommended Mix"}</div>
                <div className={styles.eLoading}>
                  <LoadingIndicator
                    style={{
                      margin: "0px",
                      marginTop: "10px"
                    }}
                    color={"#868595"}
                  />
                </div>
              </div>
            ) : (
              <div
                className={styles.eBox}
                style={{
                  justifyContent: "flex-start",
                  whiteSpace: "wrap"
                }}
              >
                <div className={styles.eDark}>{"Recommended Mix"}</div>
                <div className={styles.eSubDark}>
                  {"Aible will show the optimal resource allocation once the AI has been trained."}
                </div>
              </div>
            )}
            {isBalance ? (
              <div style={{ display: "none" }} />
            ) : isEditBlueprint ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>
                  <LineInput
                    isMediumBox
                    isDark
                    defaultValue={
                      optimized
                        ? optimized.revenueLabel
                        : setup && setup.advancedRevenueLabel
                          ? setup.advancedRevenueLabel
                          : "Revenue"
                    }
                    onChange={(val) => {
                      updateAdvancedRevenueLabel(runId, val);
                      updateAdvancedRevenueLabel("new", val);
                    }}
                  />
                </div>
                <div className={styles.eLightLarge}>{"TBD"}</div>

                <div>{"TBD"}</div>
              </div>
            ) : optimized && optimized.isCreating === false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{optimized.revenueLabel}</div>
                <div className={styles.eLightLarge}>
                  {optimized.isCurrencyUnitType ? (
                    <div>
                      {unitType}
                      {numeral(optimized.revenue).format("0.0a")}
                    </div>
                  ) : (
                    <div className={styles.nonC}>
                      {numeral(optimized.revenue).format("0.0a")}
                      <div className={styles.subLabel}>{unitType}</div>
                    </div>
                  )}
                </div>
                {isSkipped !== true ? (
                  <TinyBarChart
                    bars={[
                      {
                        label: "Optimal " + optimized.revenueLabel,
                        Cost: optimized.revenue
                      },
                      {
                        label: "Current " + optimized.revenueLabel,
                        Cost: optimized.currentRevenue
                      }
                    ]}
                    unit={optimized.unitLabel}
                    isCurrencyUnit={optimized.isCurrencyUnitType}
                  />
                ) : (
                  <div>{"Add baseline assumptions to show difference"}</div>
                )}
              </div>
            ) : optimized && optimized.isCreating ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{optimized.revenueLabel}</div>
                <div className={styles.eLoading}>
                  <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
                </div>
                {this.renderProgress(optimized.revenueLabel)}
              </div>
            ) : (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Baseline Revenue"}</div>
                <div className={styles.eSubDark}>
                  {"This uses your Business Assumption Benefits (expected revenue " +
                    "per opportunitiy) times your Total Expected Win Count."}
                </div>
                <div className={styles.eDarkLarge}>
                  {unitType === "$" ? (
                    <div>
                      {unitType}
                      {numeral(currentRevenue).format("0.0a")}
                    </div>
                  ) : (
                    <div className={styles.nonC}>
                      {numeral(currentRevenue).format("0.0a")}
                      <div className={styles.subLabel}>{unitType}</div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {isEditBlueprint ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>
                  <LineInput
                    isMediumBox
                    isDark
                    defaultValue={
                      optimized
                        ? optimized.profitLabel
                        : setup && setup.netImpactLabel
                          ? setup.netImpactLabel
                          : "Profit"
                    }
                    onChange={(val) => {
                      updateNetImpactLabel(runId, val);
                      updateNetImpactLabel("new", val);
                    }}
                  />
                </div>
                <div className={styles.eLightLarge}>{"TBD"}</div>
                <div>{"TBD"}</div>
              </div>
            ) : optimized && optimized.isCreating === false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{optimized.profitLabel}</div>
                <div className={styles.eLightLarge}>
                  {optimized.isCurrencyUnitType ? (
                    <div>
                      {unitType}
                      {numeral(optimized.profit).format("0.0a")}
                    </div>
                  ) : (
                    <div className={styles.nonC}>
                      {numeral(optimized.profit).format("0.0a")}
                      <div className={styles.subLabel}>{unitType}</div>
                    </div>
                  )}
                </div>
                {isSkipped !== true ? (
                  <TinyBarChart
                    bars={[
                      {
                        label: "Optimal " + optimized.profitLabel,
                        Cost: optimized.profit
                      },
                      {
                        label: "Current " + optimized.profitLabel,
                        Cost: optimized.currentProfit
                      }
                    ]}
                    unit={optimized.unitLabel}
                    isCurrencyUnit={optimized.isCurrencyUnitType}
                  />
                ) : (
                  <div>{"Add baseline assumptions to show difference"}</div>
                )}
              </div>
            ) : optimized && optimized.isCreating ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{optimized.profitLabel}</div>
                <div className={styles.eLoading}>
                  <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
                </div>
                {this.renderProgress(optimized.profitLabel)}
              </div>
            ) : (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Baseline Profit"}</div>
                <div className={styles.eSubDark}>
                  {"This is the sum of the unique businesss circumstances you defined" +
                    " in the Costs/Benefits and Expected Win Count across all" +
                    " potential opportunities."}
                </div>
                <div className={styles.eDarkLarge}>
                  {unitType === "$" ? (
                    <div>
                      {unitType}
                      {numeral(currentProfit).format("0.0a")}
                    </div>
                  ) : (
                    <div className={styles.nonC}>
                      {numeral(currentProfit).format("0.0a")}
                      <div className={styles.subLabel}>{unitType}</div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          {isBalance && this.renderTopSankey()}
        </div>
        {isEditBlueprint ? (
          this.renderEditBlueprintBot()
        ) : (
          <div className={styles.emptyBot}>
            {isBalance !== true && (
              <div
                className={styles.eBotHeader}
                style={
                  mSubGroup
                    ? {
                        background: mSubGroup.column === "Overall" ? "#7E69D7" : mSubGroup.color,
                        color: mSubGroup.color === "#7E69D7" || mSubGroup.column === "Overall" ? "white" : "#4B495B"
                      }
                    : {}
                }
              >
                <div className={styles.eBotHeaderItem} style={{ minWidth: "calc(40% - 40px)" }}>
                  {"Business Assumptions"}
                </div>
                <div className={styles.eBotHeaderItem} style={{ minWidth: "calc(30% - 40px)" }}>
                  {"Behavior Assumptions"}
                </div>
                <div
                  className={styles.eBotHeaderItem}
                  style={{
                    minWidth: "calc(30% - 40px)",
                    marginRight: "20px"
                  }}
                >
                  {"Key Drivers of Predictions"}
                </div>
              </div>
            )}
            {isBalance ? (
              <div className={styles.eBotSankey}>{this.renderSankey()}</div>
            ) : (
              <div className={styles.eBotBody}>
                <div className={styles.eBotItem} style={{ minWidth: "calc(40% - 40px)" }}>
                  {this.renderAssumptions()}
                </div>
                <div className={styles.eFlex}>
                  {optimized && (
                    <div className={`${styles.eBotItem} ${styles.eStrats}`}>
                      <BusinessConstraints id={id} forceDropdown />
                    </div>
                  )}
                  <div
                    className={styles.eBotItem}
                    style={{
                      padding: "0px"
                    }}
                  >
                    {!optimized ? (
                      <div />
                    ) : isOverallSegment === true ? (
                      <div />
                    ) : (
                      <div
                        className={styles.aHeader}
                        style={{
                          borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
                          padding: "20px"
                        }}
                      >
                        <div
                          style={{
                            width: "calc(100% - 75px"
                          }}
                        >
                          {"Will future " +
                            transactionLabel +
                            " and " +
                            outcomeLabel +
                            " rate match the baseline behavior assumptions?"}
                        </div>
                        <div style={{ width: "100px" }}>
                          <div id={"eToggle"} className={styles.tHolder}>
                            <Toggle
                              checked={isRealityHammer === true}
                              icons={false}
                              onChange={(e) => updateIsRealityHammer(runId, !isRealityHammer)}
                              disabled={isRealityHammer && hasLinkedProject}
                            />
                            <span className={isRealityHammer === true ? styles.yPos : styles.nPos}>
                              {isRealityHammer !== true ? "Yes" : "No"}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                    {optimized ? (
                      <div className={styles.wQuestion}>
                        <div className={styles.rHammer}>
                          <span>
                            <span>{"Potential "}</span>
                            <span
                              style={{
                                fontWeight: "bold"
                              }}
                            >
                              {transactionLabel}
                            </span>
                            <span>{" the AI will predict"}</span>
                          </span>
                          <div className={styles.wInput}>
                            <LineInput
                              isMediumBox
                              value={Math.round(total)}
                              isDisabled={isRealityHammer !== true || hasLinkedProject}
                              onChange={(val) => {
                                if (!isNaN(val)) {
                                  updateScaledTotal(runId, Number(val));
                                }
                              }}
                              style={{
                                color: "#4B495B"
                              }}
                            />
                            <div
                              style={{
                                marginRight: "15px"
                              }}
                            >
                              {" with a "}
                            </div>
                            <div
                              style={{
                                width: "80px"
                              }}
                            >
                              <LineInput
                                isMediumBox
                                value={totalWinRate}
                                isDisabled={isRealityHammer !== true}
                                onChange={(val) => {
                                  if (!isNaN(val)) {
                                    updateOutcomePercentage(runId, Number(val) / 100);
                                  }
                                }}
                                style={{
                                  color: "#4B495B"
                                }}
                              />
                            </div>
                            <div
                              style={{
                                marginLeft: "-6px"
                              }}
                            >
                              {"% potential " + outcomeLabel + " rate"}
                            </div>
                          </div>
                        </div>
                        {isRealityHammer === true &&
                          baselines &&
                          baselines.baselineTotal !== undefined &&
                          baselines.baselineTotal !== total && (
                            <div className={styles.overwrote}>
                              {"Original Baseline"}
                              <div className={styles.wInput}>
                                <LineInput
                                  isMediumBox
                                  value={
                                    baselines && baselines.baselineTotal !== undefined ? baselines.baselineTotal : total
                                  }
                                  isDisabled={true}
                                  onChange={(val) => {
                                    !isNaN(val) && updateScaledTotal(runId, Number(val));
                                  }}
                                  style={{
                                    color: "#4B495B"
                                  }}
                                />
                                <div
                                  style={{
                                    marginRight: "15px"
                                  }}
                                >
                                  {" with a "}
                                </div>
                                <div
                                  style={{
                                    width: "80px"
                                  }}
                                >
                                  <LineInput
                                    isMediumBox
                                    value={
                                      baselines && baselines.baselineWinRate !== undefined
                                        ? baselines.baselineWinRate
                                        : totalWinRate
                                    }
                                    isDisabled={true}
                                    onChange={(val) => {
                                      !isNaN(val) && updateOutcomePercentage(runId, Number(val) / 100);
                                    }}
                                    style={{
                                      color: "#4B495B"
                                    }}
                                  />
                                </div>
                                <div
                                  style={{
                                    marginLeft: "-6px"
                                  }}
                                >
                                  {"% potential " + outcomeLabel + " rate"}
                                </div>
                              </div>
                            </div>
                          )}
                        {isOverallSegment === true ? (
                          <div
                            style={{
                              marginLeft: "20px",
                              marginBottom: "20px"
                            }}
                          >
                            {"Select a subgroup to update expected behavior"}
                          </div>
                        ) : (
                          <div />
                        )}
                      </div>
                    ) : (
                      this.renderOptimizePlaceholder()
                    )}
                  </div>
                  {isEnabled("balancer") && optimized ? (
                    <div className={styles.eBotItem} style={{ marginTop: "20px" }}>
                      <div
                        className={styles.aHeader}
                        style={
                          hasLinkedProject
                            ? {
                                borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
                                paddingBottom: "20px",
                                marginBottom: "20px"
                              }
                            : {}
                        }
                      >
                        <div
                          style={{
                            width: "calc(100% - 75px"
                          }}
                        >
                          {"Is there another project that impacts the input or resourcing for this project?"}
                        </div>
                        <div style={{ width: "100px" }}>
                          <div id={"eToggle"} className={styles.tHolder}>
                            <Toggle
                              checked={hasLinkedProject === true}
                              icons={false}
                              onChange={(e) => updateHasLinkedProject(!hasLinkedProject)}
                            />
                            <span className={hasLinkedProject === true ? styles.yPos : styles.nPos}>
                              {hasLinkedProject === true ? "Yes" : "No"}
                            </span>
                          </div>
                        </div>
                      </div>
                      {hasLinkedProject && (
                        <Select
                          options={
                            projects &&
                            projects
                              .filter((p) => p.id !== project.id)
                              .map((p) => ({
                                label: p.name + " (" + p.segment_count + ")",
                                value: p.id
                              }))
                          }
                          value={
                            optimized.setup && optimized.setup.linkedProjectId !== undefined
                              ? projects && projects.filter((p) => p.id === optimized.setup.linkedProjectId).length > 0
                                ? {
                                    label:
                                      projects.filter((p) => p.id === optimized.setup.linkedProjectId)[0].name +
                                      " (" +
                                      projects.filter((p) => p.id === optimized.setup.linkedProjectId)[0]
                                        .segment_count +
                                      " )",
                                    value: optimized.setup.linkedProjectId
                                  }
                                : undefined
                              : {
                                  label: "Select a project...",
                                  value: undefined
                                }
                          }
                          menuPlacement="top"
                          onChange={(val) => updateLinkedProjectId(val.value)}
                        />
                      )}
                      {hasLinkedProject && linkedProject && (
                        <div className={styles.sSelect}>
                          {isLoadingLink ? (
                            <div className={styles.loadScenario}>
                              <div>{"Loading Project...."}</div>
                              <LoadingIndicator
                                style={{
                                  margin: "0px"
                                }}
                              />
                            </div>
                          ) : (
                            <div>
                              <div>{"Select a scenario"}</div>
                              <Select
                                options={
                                  linkedProject && linkedProject.settings && linkedProject.settings.originalScenarios
                                    ? linkedProject.settings.originalScenarios.map((s) => ({
                                        label: s.name,
                                        value: s.id
                                      }))
                                    : []
                                }
                                value={
                                  optimized.setup.linkedScenarioId !== undefined &&
                                  optimized.setup.linkedScenarioId !== "Default Scenario"
                                    ? linkedProject.settings &&
                                      linkedProject.settings.originalScenarios &&
                                      linkedProject.settings.originalScenarios.filter(
                                        (s) => s.id === optimized.setup.linkedScenarioId
                                      ).length > 0
                                      ? {
                                          label: linkedProject.settings.originalScenarios.filter(
                                            (s) => s.id === optimized.setup.linkedScenarioId
                                          )[0].name,
                                          value: optimized.setup.linkedScenarioId
                                        }
                                      : {}
                                    : {
                                        label: "Default Scenario",
                                        value: "Default Scenario"
                                      }
                                }
                                onChange={(val) => updateLinkedScenarioId(val.value)}
                                isDisabled={
                                  !(
                                    linkedProject &&
                                    linkedProject.settings &&
                                    linkedProject.settings.originalScenarios &&
                                    linkedProject.settings.originalScenarios.length
                                  )
                                }
                              />
                              <div
                                style={{
                                  marginTop: "20px"
                                }}
                              >
                                {"Select the output of " + linkedProject.name}
                              </div>
                              <Select
                                options={linkedProjectOutputModeOptions}
                                value={linkedProjectOutputModeOption}
                                onChange={({ label, value }) => updateLinkedProjectOutputMode(value)}
                              />
                              <div className={styles.balanceButtonHolder}>
                                <Button
                                  type={"primary"}
                                  onClick={() => goToBalance()}
                                  disabled={getIsContinuous(optimized.setup.linkedProjectId)}
                                >
                                  {getIsContinuous(optimized.setup.linkedProjectId)
                                    ? "Select a Categorical Project to Balance"
                                    : "Balance Projects"}
                                </Button>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className={styles.eBotItem}
                  style={{
                    minWidth: "calc(30% - 40px)",
                    marginRight: "20px"
                  }}
                >
                  {optimized && optimized.isCreating === false && !isOverallSegment ? <div></div> : ""}
                  {optimized && optimized.isCreating === false ? (
                    isOverallSegment || isDrivers ? (
                      <div>
                        <div
                          className={styles.aHeader}
                          style={{
                            marginBottom: "10px"
                          }}
                        >
                          {"Key Drivers"}
                          <PredictionDriverToolTip />
                        </div>
                        <div className={styles.nItemBotContent} style={{ overflow: "auto" }}>
                          {isOverallSegment
                            ? modelGroups.topDrivers.filter((s, i) => i > 0).map((s) => this.renderDrivers(s, 4, false))
                            : this.renderDrivers(
                                (modelGroups.topDrivers || []).find((driver) => driver.runId === optimized.innerId),
                                5,
                                true
                              )}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div
                          className={styles.runPlot}
                          style={{
                            height: this.state.isHelpClosed ? "37vh" : "30vh"
                          }}
                        >
                          {
                            <RunPlotContainer
                              id={runId}
                              isMiniOptimize
                              projectId={project ? project.id : undefined}
                              forceEnableBts
                              hideFrontier
                            />
                          }
                        </div>
                      </div>
                    )
                  ) : (
                    <div className={styles.eBotBox}>
                      <img src={PurpleFlagIcon} className={styles.eIcon} />
                      <div className={styles.eBotBoxBold}>
                        {"Once the AI has been trained this section will " +
                          "display the model that best fits your use case."}
                      </div>
                      <div>
                        {"The optimal model will be based on the cost, benefit, and" +
                          " data assumptions you have defined."}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}
